/* Sevine Dumont: productpagina, replicatie P1-P8 (01-10-2026)
   <sd-p1-product>  variant (kleur als productfoto's, maat), galerij per kleur, thumbnails,
                    add to cart (event sd:cart:added voor drawer K1 en pop-up K2), wishlist,
                    P5-paneel, P7-knoppen, P3 vaste koopbalk.
   <sdp-tabs>       P2 tabs (Polène).
   <sdp-mini-slides> P6 pijltjes op de foto's (Fleuron).
   Oude versie: wijzigingslog/2026-10-01-replicatie-backup/product/assets/sd-product.js */
(function () {
  if (window.__sdpReady) return;
  window.__sdpReady = true;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(cents, fmt) {
    if (window.SD && window.SD.formatMoney) {
      try { return window.SD.formatMoney(cents, fmt).replace(/\.00(?=\D*$)/, ''); } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
  }
  function handleize(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  class SdP1Product extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-sdp-json]');
      try { this.data = JSON.parse(json.textContent); } catch (e) { this.data = { variants: [] }; }
      this.form = this.querySelector('[data-sdp-form]');
      this.idInput = this.querySelector('[data-sdp-variant]');
      this.atc = this.querySelector('[data-sdp-atc]');
      this.colorIndex = this.dataset.colorIndex !== undefined ? +this.dataset.colorIndex : -1;
      var id = this.idInput ? +this.idInput.value : 0;
      this.current = this.data.variants.filter(function (v) { return v.id === id; })[0] || this.data.variants[0];
      this.selected = this.current ? this.current.options.slice() : [];

      this.querySelectorAll('[data-sdp-option]').forEach(function (btn) {
        btn.addEventListener('click', this.onOption.bind(this, btn));
      }, this);
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.setupThumbs();
      this.setupSwatchSlider();
      this.setupWishlist();
      this.setupPanel();
      this.setupBar();
      this.setupTerms();
      this.setupAcc2();
    }

    /* Feedback 02-10 (R3): accordeons onder de tabs, zoals Polène. Plus wordt min, hoogte schuift open (0,3 s), één tegelijk open. */
    setupAcc2() {
      var items = Array.prototype.slice.call(this.querySelectorAll('[data-sdp-acc2]'));
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var set = function (item, open) {
        var btn = item.querySelector('[data-sdp-acc2-btn]');
        var panel = item.querySelector('.sdp-acc__panel');
        if ((btn.getAttribute('aria-expanded') === 'true') === open) return;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (reduce) { panel.hidden = !open; return; }
        if (open) {
          panel.hidden = false;
          var h = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(function () { panel.style.height = h + 'px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        }
        var done = function (e) {
          if (e.target !== panel) return;
          panel.removeEventListener('transitionend', done);
          if (btn.getAttribute('aria-expanded') !== 'true') panel.hidden = true;
          panel.style.height = '';
        };
        panel.addEventListener('transitionend', done);
        window.setTimeout(function () { done({ target: panel }); }, 450);
      };
      items.forEach(function (item) {
        item.querySelector('[data-sdp-acc2-btn]').addEventListener('click', function () {
          var open = this.getAttribute('aria-expanded') !== 'true';
          items.forEach(function (other) { if (other !== item) set(other, false); });
          set(item, open);
        });
      });
    }

    onOption(btn) {
      var idx = +btn.dataset.sdpOption;
      this.selected[idx] = btn.dataset.value;
      var sel = this.selected;
      var match = this.data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!match) {
        match = this.data.variants.filter(function (v) { return v.options[idx] === sel[idx] && v.available; })[0] ||
          this.data.variants.filter(function (v) { return v.options[idx] === sel[idx]; })[0];
        if (match) this.selected = match.options.slice();
      }
      if (match) this.setVariant(match);
    }

    setVariant(v) {
      this.current = v;
      var fmt = this.data.money;
      if (this.idInput) this.idInput.value = v.id;
      this.querySelectorAll('[data-sdp-option]').forEach(function (b) {
        b.setAttribute('aria-pressed', this.selected[+b.dataset.sdpOption] === b.dataset.value ? 'true' : 'false');
      }, this);
      this.querySelectorAll('[data-sdp-price]').forEach(function (el) { el.textContent = money(v.price, fmt); });
      this.querySelectorAll('[data-sdp-bar-option]').forEach(function (sel) {
        var val = this.selected[+sel.dataset.sdpBarOption];
        if (val != null && sel.value !== val) sel.value = val;
      }, this);
      var amt = this.querySelector('[data-sdp-installment-amount]');
      if (amt) amt.textContent = money(Math.round(v.price / 4), fmt);
      if (this.colorIndex > -1) {
        var name = v.options[this.colorIndex];
        this.querySelectorAll('[data-sdp-colour-name]').forEach(function (el) { el.textContent = name; });
        this.showGroup(handleize(name));
        var barImg = this.querySelector('[data-sdp-bar-img]');
        if (barImg && v.image) barImg.src = v.image;
      }
      var restock = this.hasAttribute('data-restock');
      if (this.atc && !restock) {
        var label = this.atc.querySelector('[data-sdp-atc-text]');
        this.atc.disabled = !v.available;
        var withPrice = this.atc.dataset.priceInLabel !== 'false';
        label.textContent = v.available ? this.atc.dataset.labelAdd + (withPrice ? ' – ' + money(v.price, fmt) : '') : this.atc.dataset.labelSold;
      }
      var barBtn = this.querySelector('[data-sdp-bar-btn]');
      if (barBtn && !restock && !this.hasAttribute('data-sold')) {
        barBtn.disabled = !v.available;
        var barLabel = barBtn.querySelector('[data-sdp-bar-label]');
        if (barLabel) barLabel.textContent = v.available ? barBtn.dataset.labelAdd : barBtn.dataset.labelSold;
      }
      var dyn = this.querySelector('[data-sdp-dynamic]');
      if (dyn) dyn.hidden = !v.available;
      var low = this.querySelector('[data-sdp-low]');
      if (low) low.hidden = !v.low;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    showGroup(group) {
      var has = this.querySelector('.sdp__slide[data-group="' + group + '"]');
      if (!has) return;
      this.querySelectorAll('.sdp__slide, [data-sdp-thumbs] li').forEach(function (el) {
        var g = el.getAttribute('data-group');
        el.hidden = !!(g && g !== group);
      });
      var track = this.querySelector('[data-sdp-track]');
      if (track) track.scrollTo({ left: 0 });
      this.markThumb();
    }

    setupThumbs() {
      var track = this.querySelector('[data-sdp-track]');
      if (!track) return;
      this.querySelectorAll('[data-sdp-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          var slide = track.querySelector('[data-media-id="' + b.dataset.sdpThumb + '"]');
          if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      var t;
      track.addEventListener('scroll', function () {
        window.clearTimeout(t);
        t = window.setTimeout(this.markThumb.bind(this), 80);
      }.bind(this), { passive: true });
      this.markThumb();
    }

    markThumb() {
      var track = this.querySelector('[data-sdp-track]');
      if (!track) return;
      var slides = Array.prototype.filter.call(track.children, function (s) { return !s.hidden; });
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      var cur = slides[i] || slides[0];
      this.querySelectorAll('[data-sdp-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', cur && b.dataset.sdpThumb === cur.dataset.mediaId ? 'true' : 'false');
      });
    }

    setupSwatchSlider() {
      var track = this.querySelector('[data-sdp-swatch-track]');
      if (!track) return;
      var prev = this.querySelector('[data-sdp-swatch-prev]');
      var next = this.querySelector('[data-sdp-swatch-next]');
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = max <= 0 || track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -73 * 3 }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: 73 * 3 }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    setupWishlist() {
      var btn = this.querySelector('[data-sdp-wish]');
      if (!btn) return;
      var key = 'sd-wishlist';
      var h = btn.dataset.sdpWish;
      var read = function () { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } };
      btn.setAttribute('aria-pressed', read().indexOf(h) > -1 ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var list = read();
        var i = list.indexOf(h);
        if (i > -1) list.splice(i, 1); else list.push(h);
        try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* ignore */ }
        btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      });
    }

    /* P2 (feedback 01-10): Shopify's eigen Shop Pay-regel. Toont die niets (Installments uit), dan onze tekstregel. */
    setupTerms() {
      var box = this.querySelector('[data-sdp-installments]');
      if (!box) return;
      var fb = box.querySelector('[data-sdp-installments-fallback]');
      if (!fb) return;
      /* Fixer 02-10 (N9): de tekstregel staat er meteen; hij verdwijnt pas als de eigen regel van Shop Pay hoogte krijgt. */
      var termsBox = box.querySelector('[data-sdp-terms]');
      var check = function () {
        var terms = box.querySelector('shopify-payment-terms');
        var shown = terms && terms.getBoundingClientRect().height > 4;
        fb.hidden = !!shown;
      };
      check();
      if (termsBox && 'ResizeObserver' in window) new ResizeObserver(check).observe(termsBox);
      window.setTimeout(check, 1500);
      window.setTimeout(check, 4000);
    }

    /* P5: inschuivend paneel (desktop) of uitklapblokken (mobiel). P7-feiten openen hetzelfde paneel. */
    setupPanel() {
      this.querySelectorAll('[data-sdp-acc-trigger]').forEach(function (t) {
        t.addEventListener('click', function () {
          var item = t.closest('[data-sdp-acc]');
          var open = t.getAttribute('aria-expanded') !== 'true';
          var group = item.parentElement;
          group.querySelectorAll('[data-sdp-acc]').forEach(function (it) {
            var tr = it.querySelector('[data-sdp-acc-trigger]');
            tr.setAttribute('aria-expanded', 'false');
            it.querySelector('[data-sdp-acc-content]').hidden = true;
          });
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
          item.querySelector('[data-sdp-acc-content]').hidden = !open;
        });
      });
      this.panel = this.querySelector('[data-sdp-panel]');
      this.overlay = this.querySelector('[data-sdp-panel-overlay]');
      if (!this.panel) return;
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.panel);
      this.querySelectorAll('[data-sdp-open-panel]').forEach(function (b) {
        b.addEventListener('click', function () { this.openPanel(b.dataset.sdpOpenPanel, b); }.bind(this));
      }, this);
      this.overlay.addEventListener('click', this.closePanel.bind(this));
      this.panel.querySelector('[data-sdp-panel-close]').addEventListener('click', this.closePanel.bind(this));
      this.panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') this.closePanel(); }.bind(this));
    }

    openPanel(key, opener) {
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      if (mobile) {
        var inline = this.querySelector('.sdp-p5__mobile [data-sdp-acc][data-key="' + key + '"] [data-sdp-acc-trigger]');
        if (inline) {
          if (inline.getAttribute('aria-expanded') !== 'true') inline.click();
          inline.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      this.lastFocus = opener;
      this.panel.querySelectorAll('[data-sdp-acc]').forEach(function (it) {
        var on = it.dataset.key === key;
        it.querySelector('[data-sdp-acc-trigger]').setAttribute('aria-expanded', on ? 'true' : 'false');
        it.querySelector('[data-sdp-acc-content]').hidden = !on;
      });
      this.overlay.hidden = false;
      this.panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        this.overlay.classList.add('is-open');
        this.panel.classList.add('is-open');
        this.panel.querySelector('[data-sdp-panel-close]').focus();
      }.bind(this));
    }

    closePanel() {
      this.overlay.classList.remove('is-open');
      this.panel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () { this.overlay.hidden = true; this.panel.hidden = true; }.bind(this), 260);
      if (this.lastFocus) this.lastFocus.focus();
    }

    /* P3: vaste koopbalk zodra de echte knop uit beeld is */
    setupBar() {
      var bar = this.querySelector('[data-sdp-bar]');
      var anchor = this.querySelector('[data-sdp-buy]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      var btn = bar.querySelector('[data-sdp-bar-btn]');
      var selects = bar.querySelectorAll('[data-sdp-bar-option]');
      // Fix 04-10: the dropdowns in the bar choose the variant the same way as the swatches above
      // 09-10 16u (Jesse): colour choice in the bar opens the product of that colour (custom.color_siblings)
      var sib = bar.querySelector('[data-sdp-bar-sibling]');
      if (sib) sib.addEventListener('change', function () { if (sib.value) window.location.href = sib.value; });
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          this.onOption({ dataset: { sdpOption: sel.dataset.sdpBarOption, value: sel.value } });
        }.bind(this));
      }, this);
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
        selects.forEach(function (sel) { sel.tabIndex = show ? 0 : -1; });
        if (sib) sib.tabIndex = show ? 0 : -1;
      }).observe(anchor);
    }

    onSubmit(e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (!this.atc || this.atc.disabled || this.atc.getAttribute('aria-busy') === 'true') return;
      this.atc.setAttribute('aria-busy', 'true');
      var err = this.querySelector('[data-sdp-error]');
      if (err) err.hidden = true;
      var self = this;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'This bag could not be added. Please try again.');
          var item = res.json;
          return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return { item: item, cart: cart }; });
        })
        .then(function (res) {
          self.atc.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('sd:cart:updated', { detail: { cart: res.cart } }));
          var evt = new CustomEvent('sd:cart:added', {
            cancelable: true,
            detail: { item: res.item, cart: res.cart, productHandle: self.dataset.handle, sectionId: self.dataset.section }
          });
          if (document.dispatchEvent(evt)) window.location.href = root() + 'cart';
        })
        .catch(function (error) {
          self.atc.removeAttribute('aria-busy');
          if (err) { err.textContent = error.message; err.hidden = false; }
        });
    }
  }

  /* P2: tabs (Polène) */
  class SdpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { this.select(i); }.bind(this));
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(n);
            this.tabs[n].focus();
          }
        }.bind(this));
      }, this);
    }
    select(i) {
      this.tabs.forEach(function (tab, n) {
        var on = n === i;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; panel.classList.toggle('is-active', on); }
      });
    }
  }

  /* P6: bladeren door de foto's van één product (Fleuron) */
  class SdpMiniSlides extends HTMLElement {
    connectedCallback() {
      this.imgs = Array.prototype.slice.call(this.querySelectorAll('[data-sdp-mini]'));
      this.i = 0;
      var prev = this.querySelector('[data-sdp-mini-prev]');
      var next = this.querySelector('[data-sdp-mini-next]');
      if (prev) prev.addEventListener('click', this.go.bind(this, -1));
      if (next) next.addEventListener('click', this.go.bind(this, 1));
    }
    go(step, e) {
      if (e) e.preventDefault();
      if (this.imgs.length < 2) return;
      this.i = (this.i + step + this.imgs.length) % this.imgs.length;
      this.classList.add('is-moved');
      this.imgs.forEach(function (img, n) { img.classList.toggle('is-active', n === this.i); }, this);
    }
  }

  /* P1 (feedback 01-10): Send a hint (Cuyana). Mobiel: deelmenu. Anders: venster met mailto en link kopiëren. */
  class SdpHint extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-sdp-hint-modal]');
      this.overlay = this.querySelector('[data-sdp-hint-overlay]');
      this.opener = this.querySelector('[data-sdp-hint-open]');
      if (!this.modal || !this.opener) return;
      // venster naar body, zodat sticky/transform van de infokolom het niet afknipt
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.modal);
      this.opener.addEventListener('click', this.onOpen.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      this.modal.querySelector('[data-sdp-hint-close]').addEventListener('click', this.close.bind(this));
      this.modal.querySelector('[data-sdp-hint-send]').addEventListener('click', this.send.bind(this));
      this.modal.querySelector('[data-sdp-hint-copy]').addEventListener('click', this.copy.bind(this));
      this.onKey = function (e) { if (e.key === 'Escape') this.close(); }.bind(this);
    }
    message() {
      var t = this.modal.querySelector('[data-sdp-hint-message]');
      return (t ? t.value.trim() : '') + '\n\n' + this.dataset.url;
    }
    onOpen() {
      var touch = window.matchMedia('(hover: none), (max-width: 749px)').matches;
      if (touch && navigator.share) {
        var t = this.modal.querySelector('[data-sdp-hint-message]');
        navigator.share({ title: this.dataset.title, text: t ? t.value.trim() : '', url: this.dataset.url })
          .catch(function (err) { if (err && err.name !== 'AbortError') this.open(); }.bind(this));
        return;
      }
      this.open();
    }
    open() {
      this.overlay.hidden = false;
      this.modal.hidden = false;
      document.addEventListener('keydown', this.onKey);
      var f = this.modal.querySelector('[data-sdp-hint-to]');
      if (f) f.focus();
    }
    close() {
      this.overlay.hidden = true;
      this.modal.hidden = true;
      document.removeEventListener('keydown', this.onKey);
      this.opener.focus();
    }
    send() {
      var to = this.modal.querySelector('[data-sdp-hint-to]');
      var href = 'mailto:' + encodeURIComponent(to ? to.value.trim() : '') +
        '?subject=' + encodeURIComponent(this.dataset.subject || this.dataset.title) +
        '&body=' + encodeURIComponent(this.message());
      window.location.href = href;
    }
    copy(e) {
      var btn = e.currentTarget;
      var url = this.dataset.url;
      var done = function () { var o = btn.textContent; btn.textContent = btn.dataset.done || o; window.setTimeout(function () { btn.textContent = o; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
    }
  }

  /* Feedback 02-10 (R4): verhalen achter de infokaarten. Lade van rechts, overlay, Esc en klik buiten sluiten. */
  class SdpStories extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.overlay = this.querySelector('[data-sdp-story-overlay]');
      this.drawers = Array.prototype.slice.call(this.querySelectorAll('[data-sdp-story]'));
      if (!this.drawers.length || !this.overlay) return;
      document.body.appendChild(this.overlay);
      this.drawers.forEach(function (d) {
        document.body.appendChild(d);
        d.querySelector('[data-sdp-story-close]').addEventListener('click', this.close.bind(this));
      }, this);
      this.overlay.addEventListener('click', this.close.bind(this));
      this.onKey = function (e) { if (e.key === 'Escape') this.close(); }.bind(this);
      this.querySelectorAll('[data-sdp-story-open]').forEach(function (b) {
        b.addEventListener('click', function () { this.open(b.dataset.sdpStoryOpen, b); }.bind(this));
      }, this);
    }
    open(id, opener) {
      var d = document.getElementById(id);
      if (!d) return;
      this.current = d;
      this.opener = opener;
      this.overlay.hidden = false;
      d.hidden = false;
      d.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          this.overlay.classList.add('is-open');
          d.classList.add('is-open');
          d.querySelector('[data-sdp-story-close]').focus({ preventScroll: true });
        }.bind(this));
      }.bind(this));
    }
    close() {
      var d = this.current;
      if (!d) return;
      this.current = null;
      d.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      window.setTimeout(function () { d.hidden = true; this.overlay.hidden = true; }.bind(this), 360);
      if (this.opener) this.opener.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('sdp-stories')) customElements.define('sdp-stories', SdpStories);
  if (!customElements.get('sdp-hint')) customElements.define('sdp-hint', SdpHint);
  if (!customElements.get('sd-p1-product')) customElements.define('sd-p1-product', SdP1Product);
  if (!customElements.get('sdp-tabs')) customElements.define('sdp-tabs', SdpTabs);
  if (!customElements.get('sdp-mini-slides')) customElements.define('sdp-mini-slides', SdpMiniSlides);

  /* Eindcontrole 01-10-2026: the info column is taller than the screen, so a fixed top:96px hid
     the tabs and "Pair it with" until the end of the gallery. When it is taller than the screen,
     it now sticks with its bottom edge in view instead. */
  (function () {
    var form = document.querySelector('.sdp__form');
    if (!form) return;
    function setTop() {
      if (window.innerWidth < 990) { form.style.top = ''; return; }
      var room = window.innerHeight - 96;
      var h = form.offsetHeight;
      form.style.top = (h > room ? window.innerHeight - h - 24 : 96) + 'px';
    }
    setTop();
    window.addEventListener('resize', setTop);
    if ('ResizeObserver' in window) new ResizeObserver(setTop).observe(form);
  })();
})();
